/* eslint-disable */
import weather from '../functions/weather';
import {calcHeader, pop_credits} from '../functions/misc';
import {section_headers} from '../functions/anims';
import 'slick-carousel';
import { slickAtts } from '../functions/slider';
import { formAddToMC } from '../functions/mailchimp.js';
import { check_alerts, close_alert } from '../functions/alerts.js';
import { shareTrigger } from '../functions/social-share.js';

export default {
  init() {
    // eslint-disable-next-line
    weather;

    // Check alerts
    check_alerts();

    // Close alert
    close_alert();

    shareTrigger();

  },

  finalize() {
    // Set --header-height var
    calcHeader();
    window.addEventListener('resize', calcHeader);

    //Highlight section titles & icons
    section_headers();


    /**
     * Open credits in footer
     */
    $('.credits-reveal').on('click touch', function(e){
		  e.preventDefault();
		  pop_credits();
    });

    /**
     * Mobile navigation
     */
    $('.mobile-trigger').on('click touch', function(e){
		  e.preventDefault();
		  $(this).toggleClass('active');
		  $('html').toggleClass('no-scroll');
    });

    /**
     * Mailchimp Signup
     */
    $.each($('.form-email-signup'), function(){
		  formAddToMC($(this));
    });

    /**
     * Sliders
     */
    var slider = $('.slider-collection .row').slick(slickAtts);

		$('.slider-prev').click(function(){
			slider.slick('slickPrev');
		});

		$('.slider-next').click(function(){
			slider.slick('slickNext');
		});

		slider.on('afterChange', function(event, slick, currentSlide) {
			$('.slider-next, .slider-prev').removeClass('disabled');
			if (slick.currentSlide >= slick.slideCount - slick.options.slidesToShow) {
				$('.slider-next').addClass('disabled');
			}
			if(currentSlide === 0) {
				$('.slider-prev').addClass('disabled');
			}
		});

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js